import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/categories';

export default function ArticlePreviewSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4">
              <i className="ri-article-line"></i>
              <span>Featured Guides</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              Latest BaseTao Spreadsheet Articles
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-[500px]">
              In-depth guides and research to help you navigate the world of BaseTao Spreadsheet with confidence.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {articlePreviews.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 block"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-md bg-background-50/90 backdrop-blur-sm text-foreground-800">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-500">5 min read</span>
                  <span className="text-xs text-foreground-500">2026</span>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-[10px] group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articles/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-book-open-line"></i>
            View All Guides
          </Link>
        </div>
      </div>
    </section>
  );
}